import * as React from 'react';
import { ReactElement } from 'react';

import { DotLoading, InfiniteScroll, Popup } from 'antd-mobile';
import { sleep } from 'antd-mobile/es/utils/sleep';
import { Column, Icon, Row, Space, Text } from 'farmhub-ui-core';

import { SelectedEntityDomain } from 'api';
import { useAppSelector } from 'app';
import { EntityCardSkeleton, TitleText } from 'components';
import { PlusFilledIcon, TickIcon } from 'components/Icon';
import ContactPopup from 'components/Modal/ContactPopup';
import { selectAccount } from 'slice';
import { theme } from 'styled';
import { ENTITY_OBJECT_TYPE, getDummyArray } from 'utils';

import {
  WrapperBottomMobile,
  WrapperItemEmpty,
} from '../AccessAccountStep/styles';
import AccountCard from '../AccountCardItem';
import { MobileWrapper, PopupRow } from './styles';

interface MyEntitiesProps {
  total: number;
  refMobile: any;
  pagination?: any;
  list: Array<any>;
  loading?: boolean;
  currentList: any[];
  entityType: string;
  children: ReactElement[] | ReactElement;
  handleCreateAccount: () => void;
  renderEntityName: (e: string) => any;
  handleSelectedAccount: (value: SelectedEntityDomain) => void;
  handleChangePagination?: (page: number, pageSize?: number) => void;
}

const MyEntitiesMobile = ({
  list,
  total,
  children,
  currentList,
  entityType,
  pagination,
  refMobile,
  loading = false,
  renderEntityName,
  handleCreateAccount,
  handleSelectedAccount,
  handleChangePagination,
}: MyEntitiesProps): JSX.Element => {
  const user = useAppSelector(state => state.account.owner);
  const [visible, setVisible] = React.useState(false);
  const account = useAppSelector(selectAccount);

  const [visibleContact, setVisibleContact] = React.useState<boolean>(false);

  const loadMore = async (): Promise<void> => {
    await sleep(2000);

    if (handleChangePagination) {
      handleChangePagination(pagination.current + 1);
    }
  };

  return (
    <>
      <Row justifyContent="space-between" width="100%">
        <TitleText>Tài khoản của bạn ({account?.totalAccount})</TitleText>
        <Space height={6} />
        {account?.item?.role === 'owner' || !account?.item ? (
          <Row
            styles={{ gap: 4 }}
            width="fit-content"
            onClick={() => {
              if (
                user?.objectType ==
                ENTITY_OBJECT_TYPE.ENTITY_CONNECT_CHAIN_ENTITY
              ) {
                setVisibleContact(true);
              } else {
                handleCreateAccount();
              }
            }}
          >
            <Icon>
              <PlusFilledIcon
                color={theme.colors.primary.main}
                height={16}
                width={16}
              />
            </Icon>
            <Text color="main" size="xxs">
              Thêm mới
            </Text>
          </Row>
        ) : null}
      </Row>
      <Space height={12} />

      <Row justifyContent="space-between">{children}</Row>

      <Space height={12} />
      <WrapperBottomMobile ref={refMobile} id="detail_account">
        <Column>
          {loading && currentList.length === 0 ? (
            <>
              {getDummyArray(5).map(item => (
                <EntityCardSkeleton key={item.key} />
              ))}
            </>
          ) : currentList.length === 0 ? (
            <WrapperItemEmpty>
              <Space height={100} />
              {renderEntityName(entityType)?.icon}
              <Space height={24} />
              <Text>
                Hiện tại chưa có {renderEntityName(entityType)?.name} nào
              </Text>
              <Space height={24} />
            </WrapperItemEmpty>
          ) : (
            <>
              {currentList.map(item => (
                <AccountCard
                  key={item.id}
                  item={item}
                  onSelected={handleSelectedAccount}
                />
              ))}
              {loading && (
                <>
                  <Space height={12} />
                  {getDummyArray(5).map(item => (
                    <EntityCardSkeleton key={item.key} />
                  ))}
                </>
              )}
            </>
          )}
          <InfiniteScroll
            hasMore={currentList?.length < total}
            loadMore={loadMore}
          >
            {currentList?.length < total ? (
              <>
                <span>Đang tải</span>
                <DotLoading />
              </>
            ) : (
              <></>
            )}
          </InfiniteScroll>
          {!loading && <Space height={50} />}
        </Column>
      </WrapperBottomMobile>

      <Popup
        bodyStyle={{
          borderTopLeftRadius: '8px',
          borderTopRightRadius: '8px',
          height: 'fit-content',
          maxHeight: '-webkit-fill-available',
          display: 'flex',
          flexDirection: 'column',
        }}
        visible={visible}
        onMaskClick={() => setVisible(false)}
      >
        <PopupRow>
          <Text size="sm" weight="extraBold">
            Loại báo hàng
          </Text>
        </PopupRow>
        {list?.map(item => {
          const active = item.value == 1;

          return (
            <MobileWrapper
              active={active}
              onClick={() => {
                setVisible(false);
              }}
            >
              <Row justifyContent="space-between">
                <Row width="fit-content">
                  <Text color="dark" size="xs" weight="bold">
                    {item?.name}
                  </Text>
                </Row>
                {active && <TickIcon color="main" width={18} />}
              </Row>
            </MobileWrapper>
          );
        })}
      </Popup>
      <ContactPopup setVisible={setVisibleContact} visible={visibleContact} />
    </>
  );
};

export default MyEntitiesMobile;
